import { ServicesMapComponent } from "./mapComponent"
import { app, translate } from "../app"
import { translations } from "../translations"
import { Helmet } from "react-helmet"
import { languages } from "../locale"
import { useParams } from "react-router-dom"
import { getLocaleByZendesk } from "../helpers"
import { Breadcrumb } from "./breadcrumb"


function MapPage() {
  const { locale } = useParams()
  const languageSelected = localStorage.getItem('preferredLanguage') ?? getLocaleByZendesk(locale) ?? app.defaultLocale
  app.locale = languageSelected
  const urlLocale = languages[languageSelected]?.zendesk as string ?? languageSelected
  const isRTL = languages[languageSelected]?.rtl

  const metadata = {
    title: translate(translations.services),
    description: translate(translations.services),
    url: `${window.location.origin}/${urlLocale.toLowerCase()}/service-map`
  }

  return (
    <div className="w-full flex flex-col overflow-y-auto justify-start h-full">
      <Helmet>
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
        <meta property="og:title" content={metadata.title} />
        <meta property="og:description" content={metadata.description} />
        <meta property="og:url" content={metadata.url} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Service Map" />
        <meta name="twitter:description" content={metadata.description} />
      </Helmet>

      <div className="bg-white z-10 relative w-full px-4 sm:px-6 md:px-8 max-w-7xl map:px-0 map:mx-auto mt-8 mb-4">
        <Breadcrumb isRtl={isRTL}
          aria-label="Breadcrumb"
          items={[
            { link: `/`, title: translate(translations.home) },
            { title: translate(translations.services) }]}
        />
      </div>
      <div className="w-full h-auto">
        <ServicesMapComponent />
      </div>
    </div>
  )
}

export default MapPage